import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import GuestSavePointsCheckbox from 'components/RwdCheckout/Shared/Guest/GuestSavePointsCheckbox';
import CheckoutUtils from 'utils/Checkout';
import GuestSavePointsCheckboxEN from 'components/RwdCheckout/Shared/Guest/locales/GuestSavePointsCheckbox_en_US.js';
import GuestSavePointsCheckboxFR from 'components/RwdCheckout/Shared/Guest/locales/GuestSavePointsCheckbox_fr_CA.js';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(GuestSavePointsCheckboxEN, GuestSavePointsCheckboxFR);

const textResources = createStructuredSelector({
    joinOurFreeProgramText: getTextFromResource(getText, 'joinOurFreeProgramText')
});

const connectedGuestSavePointsCheckbox = connect(
    createSelector(textResources, texts => {
        const guestProfile = CheckoutUtils.getGuestProfile();

        return {
            ...texts,
            guestProfile,
            getText
        };
    })
);

const witGuestSavePointsCheckbox = wrapHOC(connectedGuestSavePointsCheckbox);

export default witGuestSavePointsCheckbox(GuestSavePointsCheckbox);
